import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/secciones_admin.php';

const IconEye     = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>;
const IconEyeOff  = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconEdit    = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconCheck   = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconUp      = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="18 15 12 9 6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconDown    = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="6 9 12 15 18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;

const token = () => localStorage.getItem('com_token') || '';

/* Temas: el valor va al className de la sección en Formaciones.jsx */
const TEMAS = [
  { valor: 'hero',    label: 'Claro',    swatch: '#edfaf4', texto: '#111614' },
  { valor: 'blanco',  label: 'Blanco',   swatch: '#ffffff', texto: '#111614' },
  { valor: 'oscuro',  label: 'Oscuro',   swatch: '#032D29', texto: '#8BCAAF' },
  { valor: 'oscuro2', label: 'Oscuro 2', swatch: '#111614', texto: '#8BCAAF' },
];

/* Secciones que no usan el bloque genérico y por tanto no admiten tema */
const SIN_TEMA = ['proximos'];

const VACIO_FORM = { titulo: '', subtitulo: '', texto_vacio: '', tema: 'blanco' };

export default function AdminSecciones() {
  const [tab,       setTab]       = useState('cursos');
  const [secciones, setSecciones] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);
  const [editId,    setEditId]    = useState(null);
  const [editForm,  setEditForm]  = useState(VACIO_FORM);
  const [saving,    setSaving]    = useState(false);
  const [saved,     setSaved]     = useState(null);

  const fetchSecciones = useCallback(async (pagina) => {
    setLoading(true); setError(null);
    try {
      const r = await fetch(`${API}?action=list&pagina=${pagina}`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const j = await r.json();
      if (!j.success) throw new Error(j.message || 'Error al cargar');
      setSecciones(j.data);
    } catch (e) {
      setError(e.message);
      setSecciones([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchSecciones(tab); }, [tab, fetchSecciones]);

  const post = async (accion, body) => {
    const r = await fetch(`${API}?action=${accion}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify(body),
    });
    const j = await r.json().catch(() => ({ success: false, message: 'Respuesta inválida' }));
    if (!j.success) throw new Error(j.message || 'No se pudo guardar');
    return j;
  };

  const toggleVisible = async (sec) => {
    const updated = { ...sec, visible: sec.visible ? 0 : 1 };
    try {
      await post('update', updated);
      setSecciones(prev => prev.map(s => s.id === sec.id ? updated : s));
    } catch (e) { setError(e.message); }
  };

  const moverSeccion = async (idx, dir) => {
    const arr  = [...secciones];
    const swap = idx + dir;
    if (swap < 0 || swap >= arr.length) return;
    [arr[idx], arr[swap]] = [arr[swap], arr[idx]];
    const reordenado = arr.map((s, i) => ({ ...s, orden: i + 1 }));
    setSecciones(reordenado);
    try {
      await post('reorder', { items: reordenado.map(s => ({ id: s.id, orden: s.orden })) });
    } catch (e) { setError(e.message); fetchSecciones(tab); }
  };

  const startEdit = (sec) => {
    setEditId(sec.id);
    setEditForm({
      titulo:      sec.titulo || '',
      subtitulo:   sec.subtitulo || '',
      texto_vacio: sec.texto_vacio || '',
      tema:        sec.tema || 'blanco',
    });
  };

  const saveEdit = async (sec) => {
    setSaving(true);
    try {
      await post('update', { ...sec, ...editForm });
      setSecciones(prev => prev.map(s => s.id === sec.id ? { ...s, ...editForm } : s));
      setEditId(null);
      setSaved(sec.id);
      setTimeout(() => setSaved(null), 2000);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  const inputBase = {
    padding: '.55rem .9rem', borderRadius: 10,
    border: '1.5px solid rgba(139,202,175,.35)',
    fontFamily: 'inherit', fontSize: '.88rem', color: '#111614', outline: 'none',
    width: '100%',
  };
  const labelStyle = {
    fontSize: '.7rem', fontWeight: 700, color: '#5a6a63',
    textTransform: 'uppercase', letterSpacing: '.08em',
    display: 'block', marginBottom: '.3rem',
  };

  return (
    <div style={{ padding: '2rem', fontFamily: '"DM Sans", sans-serif', maxWidth: 860, margin: '0 auto' }}>

      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'1.5rem' }}>
        <div>
          <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#111614', margin:0 }}>Secciones de páginas</h1>
          <p style={{ margin:'.3rem 0 0', color:'#5a6a63', fontSize:'.88rem' }}>Edita el título, subtítulo, color, mensaje vacío, visibilidad y orden de cada sección.</p>
        </div>
        <div style={{ display:'flex', gap:'.8rem', alignItems:'center' }}>
          <a href={tab === 'cursos' ? '/formaciones' : '/recursos'} target="_blank" rel="noopener noreferrer"
             style={{ fontSize:'.82rem', color:'#14736C', fontWeight:600 }}>
            Ver página ↗
          </a>
          <Link to="/admin/cursos" style={{ fontSize:'.82rem', color:'#14736C', fontWeight:600 }}>← Volver al admin</Link>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:'.5rem', marginBottom:'1.5rem' }}>
        {['cursos','materiales'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{
            padding:'.5rem 1.2rem', borderRadius:100, border:'1.5px solid',
            borderColor: tab===t ? '#14736C' : 'rgba(139,202,175,.3)',
            background: tab===t ? '#032D29' : '#fff',
            color: tab===t ? '#8BCAAF' : '#5a6a63',
            fontWeight:700, fontSize:'.85rem', cursor:'pointer', fontFamily:'inherit',
            textTransform:'capitalize'
          }}>
            {t === 'cursos' ? '📚 Cursos' : '🗂 Materiales'}
          </button>
        ))}
      </div>

      {error && (
        <div style={{ background:'#fef2f2', border:'1.5px solid #fecaca', borderRadius:12, padding:'.8rem 1rem', marginBottom:'1rem', color:'#b91c1c', fontSize:'.85rem' }}>
          ⚠️ {error}
        </div>
      )}

      {/* Lista */}
      {loading ? (
        <p style={{ color:'#5a6a63', fontSize:'.9rem' }}>Cargando…</p>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:'.75rem' }}>
          {secciones.map((sec, idx) => {
            const temaActual = TEMAS.find(t => t.valor === (sec.tema || 'blanco')) || TEMAS[1];
            const admiteTema = !SIN_TEMA.includes(sec.clave);

            return (
              <div key={sec.id} style={{
                background:'#fff', borderRadius:14,
                border: `1.5px solid ${sec.visible ? 'rgba(139,202,175,.25)' : 'rgba(200,200,200,.3)'}`,
                padding:'1rem 1.2rem',
                opacity: sec.visible ? 1 : 0.55,
                transition:'all .2s',
                boxShadow:'0 2px 8px rgba(0,0,0,.04)'
              }}>
                <div style={{ display:'flex', alignItems:'flex-start', gap:'1rem' }}>

                  {/* Orden */}
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'.2rem', paddingTop:'.2rem' }}>
                    <button onClick={() => moverSeccion(idx,-1)} disabled={idx===0}
                      style={{ background:'none', border:'none', cursor:'pointer', color: idx===0?'#ccc':'#5a6a63', padding:'.1rem' }}>
                      <IconUp/>
                    </button>
                    <span style={{ color:'#9ca3af', fontSize:'.72rem', fontWeight:700 }}>{idx+1}</span>
                    <button onClick={() => moverSeccion(idx,1)} disabled={idx===secciones.length-1}
                      style={{ background:'none', border:'none', cursor:'pointer', color: idx===secciones.length-1?'#ccc':'#5a6a63', padding:'.1rem' }}>
                      <IconDown/>
                    </button>
                  </div>

                  {/* Contenido */}
                  <div style={{ flex:1, minWidth:0 }}>
                    {editId === sec.id ? (
                      <div style={{ display:'flex', flexDirection:'column', gap:'.9rem' }}>

                        <div>
                          <label style={labelStyle}>Título</label>
                          <input value={editForm.titulo}
                            onChange={e => setEditForm(f => ({...f, titulo:e.target.value}))}
                            placeholder="Título de la sección"
                            style={{ ...inputBase, fontWeight:700 }}/>
                        </div>

                        <div>
                          <label style={labelStyle}>Subtítulo</label>
                          <input value={editForm.subtitulo}
                            onChange={e => setEditForm(f => ({...f, subtitulo:e.target.value}))}
                            placeholder="Descripción breve bajo el título"
                            style={inputBase}/>
                        </div>

                        <div>
                          <label style={labelStyle}>Mensaje cuando no hay contenido</label>
                          <input value={editForm.texto_vacio}
                            onChange={e => setEditForm(f => ({...f, texto_vacio:e.target.value}))}
                            placeholder="Ej: Estamos preparando la próxima edición."
                            style={inputBase}/>
                          <p style={{ margin:'.35rem 0 0', fontSize:'.72rem', color:'#9ca3af' }}>
                            Se muestra en la web si la sección queda sin cursos. Vacío = mensaje por defecto.
                          </p>
                        </div>

                        {admiteTema && (
                          <div>
                            <label style={labelStyle}>Color de fondo</label>
                            <div style={{ display:'flex', gap:'.5rem', flexWrap:'wrap' }}>
                              {TEMAS.map(t => {
                                const activo = editForm.tema === t.valor;
                                return (
                                  <button key={t.valor} type="button"
                                    onClick={() => setEditForm(f => ({...f, tema:t.valor}))}
                                    style={{
                                      display:'flex', alignItems:'center', gap:'.45rem',
                                      padding:'.4rem .8rem .4rem .45rem', borderRadius:100,
                                      border:`2px solid ${activo ? '#14736C' : 'rgba(139,202,175,.3)'}`,
                                      background:'#fff', cursor:'pointer', fontFamily:'inherit',
                                      fontSize:'.8rem', fontWeight: activo ? 700 : 500,
                                      color: activo ? '#14736C' : '#5a6a63',
                                    }}>
                                    <span style={{
                                      width:20, height:20, borderRadius:'50%',
                                      background:t.swatch,
                                      border:'1px solid rgba(0,0,0,.12)',
                                      display:'inline-block', flexShrink:0,
                                    }}/>
                                    {t.label}
                                  </button>
                                );
                              })}
                            </div>
                            <p style={{ margin:'.35rem 0 0', fontSize:'.72rem', color:'#9ca3af' }}>
                              Alterna claros y oscuros para que dos secciones seguidas no queden iguales.
                            </p>
                          </div>
                        )}

                        <div style={{ display:'flex', gap:'.5rem' }}>
                          <button onClick={() => saveEdit(sec)} disabled={saving}
                            style={{ display:'flex', alignItems:'center', gap:'.35rem', background:'#032D29', color:'#8BCAAF', border:'none', borderRadius:100, padding:'.5rem 1.1rem', fontWeight:700, fontSize:'.82rem', cursor: saving?'wait':'pointer', fontFamily:'inherit', opacity: saving?.6:1 }}>
                            <IconCheck/> {saving ? 'Guardando…' : 'Guardar'}
                          </button>
                          <button onClick={() => setEditId(null)}
                            style={{ background:'none', border:'1.5px solid rgba(139,202,175,.3)', borderRadius:100, padding:'.5rem 1.1rem', fontWeight:600, fontSize:'.82rem', cursor:'pointer', color:'#5a6a63', fontFamily:'inherit' }}>
                            Cancelar
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div style={{ display:'flex', alignItems:'center', gap:'.6rem', marginBottom:'.25rem', flexWrap:'wrap' }}>
                          <strong style={{ fontSize:'.95rem', color:'#111614' }}>{sec.titulo}</strong>
                          <span style={{ fontSize:'.7rem', background:'#f3f8f5', color:'#5a6a63', borderRadius:6, padding:'1px 8px', fontWeight:600 }}>{sec.clave}</span>
                          {admiteTema && (
                            <span title={`Fondo: ${temaActual.label}`} style={{
                              display:'inline-flex', alignItems:'center', gap:'.3rem',
                              fontSize:'.7rem', color:'#9ca3af', fontWeight:600,
                            }}>
                              <span style={{ width:12, height:12, borderRadius:'50%', background:temaActual.swatch, border:'1px solid rgba(0,0,0,.15)', display:'inline-block' }}/>
                              {temaActual.label}
                            </span>
                          )}
                          {saved === sec.id && <span style={{ fontSize:'.72rem', color:'#14736C', fontWeight:700 }}>✓ Guardado</span>}
                        </div>
                        {sec.subtitulo && <p style={{ margin:0, fontSize:'.82rem', color:'#5a6a63', lineHeight:1.5 }}>{sec.subtitulo}</p>}
                        {sec.texto_vacio && (
                          <p style={{ margin:'.4rem 0 0', fontSize:'.75rem', color:'#9ca3af', fontStyle:'italic' }}>
                            Si está vacía: “{sec.texto_vacio}”
                          </p>
                        )}
                      </>
                    )}
                  </div>

                  {/* Acciones */}
                  {editId !== sec.id && (
                    <div style={{ display:'flex', gap:'.4rem', flexShrink:0 }}>
                      <button onClick={() => startEdit(sec)} title="Editar"
                        style={{ background:'#f3f8f5', border:'1.5px solid rgba(139,202,175,.3)', borderRadius:8, padding:'.45rem .6rem', cursor:'pointer', color:'#14736C', display:'flex', alignItems:'center' }}>
                        <IconEdit/>
                      </button>
                      <button onClick={() => toggleVisible(sec)} title={sec.visible ? 'Ocultar sección' : 'Mostrar sección'}
                        style={{ background: sec.visible ? '#edfaf4' : '#f3f4f6', border:'1.5px solid', borderColor: sec.visible?'rgba(139,202,175,.4)':'rgba(200,200,200,.4)', borderRadius:8, padding:'.45rem .6rem', cursor:'pointer', color: sec.visible?'#14736C':'#9ca3af', display:'flex', alignItems:'center' }}>
                        {sec.visible ? <IconEye/> : <IconEyeOff/>}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}